import { useQuery } from 'react-query';

import { OrganisationUsage } from '../../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

const useFetchOrgUsageData = (
  enabled: boolean,
  startDate: string,
  endDate: string,
  matterId?: string,
  userId?: string,
  orgId?: string,
  billableOnly?: boolean,
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<OrganisationUsage>(
    [QueryEntity.OrgUsageData, startDate, endDate, matterId, userId, orgId, billableOnly],
    () => {
      const url = new URL(`${APIBaseChronos}/api/org/usage-data`);
      url.searchParams.append('start', startDate);
      url.searchParams.append('end', endDate);
      if (matterId) url.searchParams.append('matterId', matterId);
      if (userId) url.searchParams.append('userId', userId);
      if (orgId) url.searchParams.append('orgId', orgId);
      if (billableOnly) url.searchParams.append('billableOnly', 'true');

      return fetch(url.toString(), {
        ...fetchConfigGET,
        method: FetchMethod.GET,
      })
        .then((res) => res.json())
        .catch((err) => {
          console.error(err);
        });
    },
    {
      enabled,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );
};

export default useFetchOrgUsageData;
